import React from 'react';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import {
  FDTitleText, FDPaper, FDStack, FDTooltip, FDIcon, FDBodyText,
} from '@facet-wealth/design';

export const GuidedHouseholdReviewFamilyLayout = () => {
  const { resource } = useMetaLayoutContext();
  return (
    <FDStack direction={'column'} spacing={4}>
      <FDPaper padding={4}>
        <FDStack direction={'column'} spacing={2}>
          {/*  Header Row */}
          <FDStack direction={'row'} spacing={2} justifyContent={'space-between'} alignItems={'center'}>
            <FDTitleText
              flex={4}
              size={'lg'}
              value={resource.attr('familyMembers').meta().field('title').attr('prompt')}
            />
            <FDTitleText
              flex={2}
              size={'lg'}
              value={resource.attr('familyMembers').meta().field('relation').attr('prompt')}
              align={'end'}
            />
            <FDTitleText
              flex={1}
              size={'lg'}
              value={resource.attr('familyMembers').meta().field('age').attr('prompt')}
              align={'end'}
            />
          </FDStack>
          {resource.attr('familyMembers').resources().list().map(member => {
            const color = member.attr('problem') ? 'textError' : undefined;
            return (
              <FDStack
                direction={'row'}
                spacing={2}
                justifyContent={'space-between'}
                alignItems={'center'}
                key={member.id()}
              >
                <FDStack flex={4} spacing={1} alignItems="flex-end" justifyContent="flex-start">
                  <FDBodyText
                    color={color}
                    size={'md'}
                    value={member.attr('title')}
                  />
                  {member.attr('problem') ? (
                    <FDTooltip title={member.attr('problem')} placement="top">
                      <FDIcon icon="error" color="error" />
                    </FDTooltip>
                  ) : null}
                </FDStack>
                <FDBodyText color={color} flex={2} size={'md'} value={member.attr('relation')} align={'end'} />
                <FDBodyText color={color} flex={1} size={'md'} value={member.attr('age')} align={'end'} />
              </FDStack>
            );
          })}
        </FDStack>
      </FDPaper>
      <FDPaper padding={4}>
        <FDStack direction={'row'} spacing={2} justifyContent={'space-between'} alignItems={'center'}>
          <FDStack direction={'row'} spacing={1} alignItems={'center'}>
            <FDTitleText
              size={'lg'}
              value={resource.metaField('physicalAddress').attr('prompt')}
            />
            <FDTooltip
              title={'This is your primary address. If you have multiple addresses, this should be the one you use for state tax purposes.'}
              placement="top"
            >
              <FDIcon icon={'tooltip'} color={'primary'} size={'sm'} />
            </FDTooltip>
          </FDStack>
          <FDBodyText size={'md'} value={resource.attr('physicalAddress')} />
        </FDStack>
      </FDPaper>
    </FDStack>
  );
};
